/* eslint-disable prefer-const */
/* eslint-disable react/self-closing-comp */
/* eslint-disable object-shorthand */
/* eslint-disable import/no-unresolved */
/* eslint-disable prettier/prettier */
import {
  Container,
  Stack,
  Typography,
  Button,
  Icon,
  SpeedDial,
  SpeedDialIcon,
  SpeedDialAction,
  Card,
  Grid,
  TextField
} from '@mui/material';
import React, { useState } from 'react';
import Page from 'src/components/Page';
import { Link as RouterLink, useNavigate, useParams } from 'react-router-dom';
import skipBackOutline from '@iconify/icons-eva/skip-back-outline';
import SaveIcon from '@mui/icons-material/Save';
import { useFormik } from 'formik';
import * as yup from 'yup';
import MyDropzone from 'src/components/MyDropzone';
import axios from 'axios';
import { config } from 'src/helpers/config';
import authHeader from 'src/helpers/authHeader';
import { NotificationManager } from 'react-notifications';

export default function Media() {
  const [deletedFiles, setDeletedFiles] = useState([]);
  const [files, setFiles] = useState([]);
  const { id } = useParams();
  const navigate = useNavigate();

  const validationSchema = yup.object({
    title: yup.string('Wprowadź tytuł').required('To pole jest obowiązkowe'),
    link: yup.string('Wprowadź link').required('To pole jest obowiązkowe')
  });

  const formik = useFormik({
    initialValues: {
      title: '',
      link: ''
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      console.log(values);
      const formData = new FormData();
      formData.append('image', files[0]);
      formData.append('title', values.title);
      formData.append('link', values.link);

      if (id) {
        deletedFiles.map((id) => formData.append('deletedImages', id));
        formData.append('id', id);
        axios
          .put(`${config.apiAdminUrl}trip`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              ...authHeader()
            }
          })
          .then(() => {
            NotificationManager.success('Wizyta została zautualizowana!', '', 3000);
            navigate('/dashboard/trips');
          })
          .catch((e) =>
            NotificationManager.error('Wystąpił jakiś błąd! Skontaktuj się z Łukaszem!', '', 3000)
          );
      } else {
        axios
          .post(`${config.apiAdminUrl}media`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              ...authHeader()
            }
          })
          .then(() => {
            NotificationManager.success('Wizyta została dodana!', '', 3000);
            navigate('/dashboard/trips');
          })
          .catch((e) =>
            NotificationManager.error('Wystąpił jakiś błąd! Skontaktuj się z Łukaszem!', '', 3000)
          );
      }
    }
  });

  return (
    <Page title="Media">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Media
          </Typography>
          <span>
            <Button
              sx={{
                marginRight: '5px'
              }}
              variant="contained"
              component={RouterLink}
              to="/dashboard"
              startIcon={<Icon icon={skipBackOutline} />}
            >
              Wróć
            </Button>
          </span>
        </Stack>
        <Card
          sx={{
            padding: '25px'
          }}
        >
          <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  size="small"
                  fullWidth
                  id="title"
                  name="title"
                  label="Tytuł"
                  value={formik.values.title}
                  onChange={formik.handleChange}
                  error={formik.touched.title && Boolean(formik.errors.title)}
                  helperText={formik.touched.title && formik.errors.title}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  size="small"
                  fullWidth
                  id="link"
                  name="link"
                  label="Link"
                  maxRows={5}
                  rows={3}
                  multiline
                  value={formik.values.link}
                  onChange={formik.handleChange}
                  error={formik.touched.link && Boolean(formik.errors.link)}
                  helperText={formik.touched.link && formik.errors.link}
                />
              </Grid>
              <Grid item xs={12}>
                <MyDropzone
                  files={files}
                  handleFiles={(e) => setFiles(e)}
                  handleDeletedFiles={(e) => {
                    let _deletedFiles = deletedFiles;
                    _deletedFiles.push(e);
                    setDeletedFiles(_deletedFiles);
                  }}
                />
              </Grid>
              <SpeedDial
                ariaLabel="SpeedDial basic example"
                sx={{ position: 'fixed', bottom: 16, right: 16 }}
                icon={<SpeedDialIcon />}
              >
                <SpeedDialAction
                  component={Button}
                  type="submit"
                  icon={<SaveIcon />}
                  tooltipTitle="Zapisz"
                />
              </SpeedDial>
            </Grid>
            <SpeedDial
              ariaLabel="SpeedDial basic example"
              sx={{ position: 'fixed', bottom: 16, right: 16 }}
              icon={<SpeedDialIcon />}
            >
              <SpeedDialAction
                component={Button}
                type="submit"
                icon={<SaveIcon />}
                tooltipTitle="Zapisz"
              />
            </SpeedDial>
          </form>
        </Card>
      </Container>
    </Page>
  );
}
